import { ChangeEvent, FormEvent, useState } from 'react';
import { post } from '../api';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { passwordSchema } from '../validation';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);

    const result = passwordSchema.safeParse(password);
    if (!result.success) {
      setError(result.error.issues[0].message);
      return;
    }

    setLoading(true);
    try {
      await post('auth/reset-password', { token, password });
      setDone(true);
    } catch (e: any) {
      setError(
        e?.response?.data?.message ||
          'Invalid or expired link. Please request a new one.'
      );
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="columns">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <h2 className="title is-4">Invalid link</h2>
          <p>This reset link is missing or invalid.</p>
          <p className="mt-4">
            <Link to="/forgot-password">Request a new reset link</Link>
          </p>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="columns">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <h2 className="title is-4">Password reset</h2>
          <p>Your password has been updated.</p>
          <p className="mt-4">
            <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="columns">
      <div className="column is-half is-offset-one-quarter">
        <h2 className="title is-4">Choose a new password</h2>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="label">New password</label>
            <input
              className={`input${error ? ' is-danger' : ''}`}
              type="password"
              value={password}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setPassword(e.target.value)
              }
              autoFocus
            />
            {error && <p className="help is-danger">{error}</p>}
          </div>
          <button
            className={`button is-primary${loading ? ' is-loading' : ''}`}
            type="submit"
          >
            Reset password
          </button>
        </form>
      </div>
    </div>
  );
}
